import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

const getCheckoutViews = props => {
  return <LazyLoaderWrapper {...props} testId='CheckoutViews' importPath='CHECKOUT_VIEWS'></LazyLoaderWrapper>;
};

const CheckoutViews = props => {
  return getCheckoutViews(props);
};

export default CheckoutViews;
